import { ComunicacionService } from './../services/comunicacionService/comunicacion.service';
import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-error404',
  templateUrl: './error404.component.html',
  styleUrls: ['./error404.component.css']
})
export class Error404Component   {

  @Output() pagina404: EventEmitter<any> = new EventEmitter();
  constructor(private comunicacionService:ComunicacionService) { }

  
  ngOnDestroy(){
    this.comunicacionService.enviarData('error404')
  }

}
